import axios from 'axios';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';

import { GoogleLoginSuccessCallback } from '../../../components/google-login/useGoogleLoginIFrameEventListener';
import { RecaptchaAction } from '../../../components/recaptcha/RecaptchaAction';
import { useGoogleCallback } from '../../../components/recaptcha/useGoogleCallback';
import { LoginErrorType, useLoginForm } from './LoginFormContext';
import { GoogleLoginBody, LoginResponse } from './LoginSchemas';

export function useGoogleSignInCallback(): GoogleLoginSuccessCallback {
    const router = useRouter();
    const { setLoginErrorType } = useLoginForm();

    const handleSuccess = useCallback(
        async (googleCredential: string, recaptchaToken: string | undefined) => {
            const result = await axios.post<LoginResponse>('/api/login', {
                googleCredential,
                agreementCheckbox: true,
                recaptchaToken,
            } satisfies GoogleLoginBody);
            if (result.data.success) {
                router.push(result.data.redirectTo ?? '/');
            } else if (result.data.reason === 'googleUserNotFound') {
                router.push('/sign-up');
            } else {
                setLoginErrorType(LoginErrorType.INVALID_CREDENTIALS);
            }
        },
        [router, setLoginErrorType],
    );

    const handleError = useCallback(() => setLoginErrorType(LoginErrorType.INVALID_CREDENTIALS), [setLoginErrorType]);

    return useGoogleCallback({
        action: RecaptchaAction.LOGIN_WITH_GOOGLE,
        onSuccess: handleSuccess,
        onError: handleError,
    });
}
